/**
 * src/data/toolContent.js — nội dung TĨNH của mỗi trang công cụ.
 *
 * Vì sao tách khỏi component: phần này được render sẵn thành HTML lúc build
 * (xem scripts/prerender.mjs), nên Googlebot và người dùng mạng chậm đều đọc
 * được ngay mà không cần chạy JavaScript. Phần form tương tác mới cần JS.
 *
 * Nội dung ở đây cũng là toàn bộ giá trị SEO của trang: tiêu đề, đoạn mở đầu
 * và các câu hỏi thường gặp. Cái form không có giá trị SEO nào.
 *
 * `faq` được xuất ra JSON-LD dạng FAQPage — đây là loại dữ liệu có cấu trúc dễ
 * được Google hiển thị mở rộng trong kết quả tìm kiếm nhất.
 */

export const TOOL_CONTENT = {
  'founder-equity-split': {
    intro:
      'Chia cổ phần giữa những người sáng lập là quyết định khó đảo ngược nhất ' +
      'trong năm đầu tiên. Công cụ này không nói cho bạn tỷ lệ đúng. Nó dựng một ' +
      'mốc tham chiếu minh bạch từ sáu yếu tố đóng góp, rồi soi bản chia mà nhóm ' +
      'bạn đã định để chỉ ra chỗ có rủi ro.',
    faq: [
      {
        q: 'Chia đều 50/50 có sai không?',
        a: 'Không sai, nếu đóng góp thực sự tương đương và có thoả thuận vesting đi kèm. ' +
           'Vấn đề nằm ở chia đều mà không vesting: khi một người rời đi sau vài tháng, ' +
           'họ vẫn giữ nguyên phần của mình và công ty gần như không gọi được vốn nữa.',
      },
      {
        q: 'Vesting là gì và vì sao nhà đầu tư luôn hỏi?',
        a: 'Vesting nghĩa là cổ phần được nhận dần theo thời gian làm việc thay vì nhận ' +
           'hết ngay. Thông lệ là 4 năm với cliff 12 tháng: chưa đủ 12 tháng thì chưa ' +
           'nhận được gì, sau đó nhận dần từng tháng. Nhà đầu tư hỏi vì đó là thứ giữ ' +
           'nhóm sáng lập ở lại sau khi tiền đã vào.',
      },
      {
        q: 'Người nghĩ ra ý tưởng có nên được nhiều cổ phần hơn?',
        a: 'Thường là không nhiều như họ nghĩ. Mốc tham chiếu ở đây chỉ dành 5 trên 100 ' +
           'điểm cho ý tưởng, vì phần lớn giá trị được tạo ra trong lúc thực thi. Bạn ' +
           'có thể chỉnh lại trọng số nếu nhóm mình thấy khác.',
      },
    ],
  },

  runway: {
    intro:
      'Runway là số tháng công ty còn hoạt động được với lượng tiền hiện có. Đây là ' +
      'con số đầu tiên mọi nhà đầu tư hỏi, và cũng là con số quyết định bạn đàm phán ' +
      'ở thế mạnh hay thế yếu. Nhập tiền mặt và chi phí thực tế từng tháng, công cụ ' +
      'tính runway kèm các kịch bản khi tình hình xấu đi.',
    faq: [
      {
        q: 'Runway bao nhiêu tháng là đủ để bắt đầu gọi vốn?',
        a: 'Một vòng angel hoặc pre-seed ở Việt Nam thường mất 3–6 tháng từ lúc bắt đầu ' +
           'gặp nhà đầu tư tới lúc tiền thực sự về tài khoản. Nên bắt đầu khi còn ít nhất ' +
           '9–12 tháng runway. Dưới 6 tháng, bạn sẽ phải nhận điều khoản mà bên kia đưa ra.',
      },
      {
        q: 'Nên tính burn theo tháng gần nhất hay trung bình 3 tháng?',
        a: 'Trung bình 3 tháng ổn định hơn vì không bị một khoản chi bất thường làm lệch. ' +
           'Nếu bạn vừa thay đổi lớn về nhân sự hoặc chi phí, tháng gần nhất phản ánh ' +
           'đúng hiện trạng hơn.',
      },
      {
        q: 'Gọi bao nhiêu tiền thì hợp lý?',
        a: 'Thông lệ là đủ nuôi 18 tháng tới cột mốc tiếp theo, cộng thêm thời gian cho ' +
           'vòng sau. Công cụ tự tính số tiền cần gọi để đạt mức đó từ burn hiện tại.',
      },
    ],
  },

  'readiness-score': {
    intro:
      'Trước khi gửi hồ sơ đi, có vài việc nhà đầu tư gần như luôn kiểm tra. ' +
      'Công cụ này chấm hồ sơ của bạn trên năm trục (đội ngũ, vấn đề, bằng ' +
      'chứng nhu cầu, thị trường, hồ sơ tài chính pháp lý) rồi sắp xếp việc ' +
      'cần làm theo thứ tự lấy lại được nhiều điểm nhất.',
    faq: [
      {
        q: 'Điểm bao nhiêu thì nên bắt đầu gặp nhà đầu tư?',
        a: 'Từ 80 trở lên là hồ sơ đã gọn. Nhưng điểm không phải thứ quyết định. ' +
           'Điều quan trọng hơn là không còn cờ đỏ nào, đặc biệt là vesting và ' +
           'người sáng lập toàn thời gian.',
      },
      {
        q: 'Vì sao trục đội ngũ nặng hơn các trục khác?',
        a: 'Ở vòng angel và pre-seed, gần như chưa có số liệu gì để đánh giá. Nhà ' +
           'đầu tư đặt cược vào người. Trọng số 30 trên 100 phản ánh đúng cách họ ' +
           'thực sự ra quyết định ở giai đoạn này.',
      },
      {
        q: 'Tôi chưa điền hết thì điểm có bị thấp oan không?',
        a: 'Công cụ phân biệt "chưa đạt" với "chưa điền". Ô chưa điền không bị coi ' +
           'là trượt, nhưng sẽ làm giảm độ phủ dữ liệu, và độ phủ thấp thì bản ' +
           'thân con số điểm cũng chưa đáng tin.',
      },
    ],
  },

  'raise-planner': {
    intro:
      'Sai lầm phổ biến nhất khi gọi vốn lần đầu là lấy mức đốt tiền hiện tại ' +
      'nhân với 18 tháng. Nhưng tiền gọi về chính là để tăng chi (tuyển người, ' +
      'đẩy bán hàng), nên con số đó luôn thiếu. Công cụ này mô phỏng từng tháng ' +
      'có tính đà tăng chi phí, rồi cộng dồn.',
    faq: [
      {
        q: 'Nên gọi đủ cho bao nhiêu tháng?',
        a: 'Thông lệ là 18 tháng: đủ để đạt một cột mốc đáng kể, cộng thêm 3–6 ' +
           'tháng để chạy vòng tiếp theo. Dưới 12 tháng là bạn sẽ phải quay lại ' +
           'gọi vốn gần như ngay sau khi đóng vòng này.',
      },
      {
        q: 'Gọi nhiều hơn để chắc ăn có được không?',
        a: 'Gọi nhiều thì pha loãng nhiều. Thông lệ vòng đầu là bán 10–25% công ty. ' +
           'Trên mức đó, các vòng sau sẽ chật chội và nhà đầu tư vòng sau sẽ lo ' +
           'người sáng lập không còn đủ động lực.',
      },
      {
        q: 'Dự phòng bao nhiêu là hợp lý?',
        a: '15–20%. Kế hoạch nào cũng trượt, và nhà đầu tư coi khoản dự phòng là ' +
           'dấu hiệu bạn hiểu rủi ro chứ không phải dấu hiệu thiếu tự tin.',
      },
    ],
  },

  'legal-checklist': {
    intro:
      'Phần lớn việc pháp lý ở giai đoạn đầu không khó, chỉ là không ai nói cho ' +
      'biết cần làm gì. Công cụ này liệt kê những mục thường được hỏi trong thẩm ' +
      'định, nói rõ vì sao chúng quan trọng, và xếp theo thứ tự nên xử lý. Đây ' +
      'không phải tư vấn pháp lý.',
    faq: [
      {
        q: 'Chưa thành lập công ty có gọi vốn được không?',
        a: 'Với nhà đầu tư cá nhân thì đôi khi thu xếp được sau, nhưng sẽ làm chậm ' +
           'việc đóng vòng. Quỹ thì gần như luôn yêu cầu có pháp nhân trước. Hộ ' +
           'kinh doanh không phát hành được cổ phần nên không nhận vốn theo cách ' +
           'thông thường.',
      },
      {
        q: 'Vì sao chuyển giao sở hữu trí tuệ lại quan trọng đến thế?',
        a: 'Nếu mã nguồn, thiết kế hay thương hiệu vẫn đứng tên cá nhân thì công ty ' +
           'không thực sự sở hữu thứ nhà đầu tư đang mua. Thẩm định pháp lý luôn ' +
           'kiểm tra mục này và phát hiện ra ngay.',
      },
      {
        q: 'Đăng ký nhãn hiệu có gấp không?',
        a: 'Ở Việt Nam nhãn hiệu theo nguyên tắc ai nộp trước được trước, và thời ' +
           'gian xử lý tính bằng năm. Nhiều doanh nghiệp phát hiện tên mình đã bị ' +
           'người khác đăng ký đúng lúc bắt đầu được biết tới.',
      },
    ],
  },

  'fund-match': {
    intro:
      'Ở Việt Nam có hàng chục quỹ, vườn ươm và nhà đầu tư cá nhân, mỗi bên một ' +
      'khẩu vị riêng về ngành, giai đoạn, địa bàn và quy mô séc. Công cụ này đối ' +
      'chiếu hồ sơ của bạn với từng bên và nói rõ khớp hay lệch ở đâu. Quan ' +
      'trọng hơn con số phần trăm là phần lý do.',
    faq: [
      {
        q: 'Vì sao một quỹ điểm cao vẫn bị đánh dấu loại?',
        a: 'Vì có điều kiện bắt buộc không đạt, ví dụ quỹ chỉ đầu tư doanh nghiệp ' +
           'đặt trụ sở tại một địa bàn. Điều kiện bắt buộc được xét tách khỏi ' +
           'chấm điểm: gửi hồ sơ vào đó chắc chắn không có kết quả, dù mọi tiêu ' +
           'chí khác đều khớp.',
      },
      {
        q: 'Nên gửi hồ sơ cho bao nhiêu quỹ?',
        a: 'Gửi có chọn lọc hiệu quả hơn gửi hàng loạt. Một hồ sơ được viết riêng ' +
           'cho quỹ có khẩu vị đúng sẽ được đọc, còn thư gửi hàng loạt thì thường ' +
           'không. Ưu tiên những nơi khớp cả ngành lẫn giai đoạn.',
      },
      {
        q: 'Dữ liệu khẩu vị quỹ lấy từ đâu?',
        a: 'Từ thông tin công khai do chính các quỹ công bố, kèm nguồn và ngày ' +
           'kiểm chứng cho từng mục. Chúng tôi không đại diện cho quỹ nào và không ' +
           'nhận phí giới thiệu từ startup.',
      },
    ],
  },

  'valuation-preseed': {
    intro:
      'Định giá vòng đầu là kết quả đàm phán, không phải kết quả tính toán. Công ' +
      'cụ này cho một khoảng tham chiếu dựa trên mặt bằng thị trường và hồ sơ của ' +
      'bạn, để bạn không bước vào phòng họp với con số vô lý theo hướng nào cũng vậy.',
    faq: [
      {
        q: 'Vì sao không dùng bội số doanh thu?',
        a: 'Ở pre-seed doanh thu thường bằng 0 hoặc quá nhỏ. Nhân một bội số bất ' +
           'kỳ với 0 vẫn bằng 0. Phương pháp chấm điểm phù hợp hơn: lấy mặt bằng ' +
           'thị trường cho cùng giai đoạn rồi điều chỉnh theo từng trục của hồ sơ. ' +
           'Nếu công ty đã có doanh thu đều đặn, dùng công cụ định giá khi đã có doanh thu.',
      },
      {
        q: 'Công cụ chấm hồ sơ theo những trục nào?',
        a: 'Sáu trục, trọng số phỏng theo bảng chấm điểm của nhà đầu tư thiên thần Bill Payne: ' +
           'đội ngũ 30, thị trường 20, bằng chứng nhu cầu 20, kênh bán hàng 10, vấn đề và sản phẩm 10, ' +
           'số vốn cần gọi 10. Nếu đã làm công cụ điểm sẵn sàng gọi vốn, bấm lấy kết quả để các trục ' +
           'được điền tự động từ câu trả lời của bạn. Ngoài ra có ba câu hỏi chết deal không tính vào ' +
           'hệ số nhưng khiến nhiều nhà đầu tư dừng lại bất kể định giá.',
      },
      {
        q: 'Định giá cao có tốt hơn không?',
        a: 'Không hẳn. Định giá quá cao ở vòng đầu khiến vòng sau khó. Nếu chưa ' +
           'đạt cột mốc tương xứng, bạn sẽ phải gọi vốn ở mức thấp hơn, điều mà ' +
           'nhà đầu tư hiện hữu rất ngại.',
      },
      {
        q: 'Tìm mức tham chiếu của thị trường ở đâu?',
        a: 'Từ các vòng gọi vốn đã công bố trong cùng ngành và cùng giai đoạn tại ' +
           'Việt Nam. Đừng lấy số liệu thị trường nước ngoài, vì mặt bằng khác nhau ' +
           'rất xa.',
      },
    ],
  },

  'valuation-revenue': {
    intro:
      'Khi công ty đã có doanh thu đều đặn, nhà đầu tư không còn chấm điểm hồ sơ mà nhìn vào ' +
      'con số: doanh thu hoặc lợi nhuận của bạn đáng bao nhiêu lần, so với các công ty cùng ngành. ' +
      'Công cụ này tính khoảng định giá trước vòng bằng hai cách nhà đầu tư hay dùng, so sánh bội ' +
      'số và phương pháp VC, rồi chỉ ra chỗ hai cách gặp nhau.',
    faq: [
      {
        q: 'Lấy bội số so sánh ở đâu?',
        a: 'Từ doanh nghiệp niêm yết cùng ngành trên HOSE: lấy vốn hoá cộng nợ vay trừ tiền mặt, ' +
           'chia cho doanh thu hoặc EBITDA bốn quý gần nhất. Hoặc từ thương vụ có công bố cả số tiền ' +
           'lẫn tỷ lệ. Ghi tên công ty và ngày lấy số, vì nhà đầu tư sẽ hỏi nguồn.',
      },
      {
        q: 'Vì sao phải trừ chiết khấu?',
        a: 'Startup nhỏ hơn doanh nghiệp niêm yết, chưa có lịch sử lợi nhuận và cổ phần khó bán lại. ' +
           'Nhà đầu tư sẽ trừ cho từng điều đó. Bạn tự nêu mức chiết khấu trước thì cuộc trao đổi ' +
           'chuyển sang bàn phương pháp thay vì bàn cảm giác.',
      },
      {
        q: 'Khi nào dùng doanh thu, khi nào dùng EBITDA?',
        a: 'Còn đang đốt tiền thì dùng doanh thu, vì lợi nhuận âm không nhân bội số được. Đã có lãi ' +
           'ổn định vài quý thì dùng EBITDA, và lúc đó DCF cũng bắt đầu có nghĩa. DCF làm trong mẫu ' +
           'Excel định giá vì cần dự phóng 5 năm.',
      },
      {
        q: 'Vì sao phương pháp VC thường cho số thấp nhất?',
        a: 'Quỹ cần mỗi khoản có khả năng nhân vốn khoảng 10 lần để bù cho những khoản thất bại. ' +
           '10 lần trong 5 năm tương đương gần 60% mỗi năm, cao hơn nhiều so với kỳ vọng của người ' +
           'mua cổ phiếu niêm yết. Hiểu điều này giúp bạn bớt bất ngờ khi nhận term sheet.',
      },
    ],
  },

  'term-sheet': {
    intro:
      'Định giá là con số ai cũng đọc trong term sheet, nhưng thường không phải con số quyết định ' +
      'bạn nhận được bao nhiêu. Công cụ này tính ba chỗ ít người tính thử: quỹ cổ phiếu thưởng làm ' +
      'định giá thực thấp đi bao nhiêu, quyền ưu tiên thanh toán chia tiền thế nào khi bán công ty, ' +
      'và chống pha loãng lấy thêm bao nhiêu nếu vòng sau giảm giá. Sau đó soát mười điều khoản ' +
      'còn lại, trong đó có hai cờ đỏ hay gặp ở Việt Nam: founder phải cam kết mua lại cổ phần bằng ' +
      'tài sản cá nhân, và phí phạt nếu không ký hợp đồng chính.',
    faq: [
      {
        q: 'Vì sao cam kết mua lại cổ phần lại bị đánh dấu nghiêm trọng?',
        a: 'Vì nó chuyển rủi ro của nhà đầu tư sang tài sản riêng của founder. Nếu công ty không đạt ' +
           'mục tiêu, founder phải tự bỏ tiền mua lại cổ phần, có khi kèm lãi cam kết. Khi đó khoản ' +
           'đầu tư thực chất là khoản vay đứng tên founder. Xem thêm bài Term sheet ở Việt Nam trong Playbook.',
      },
      {
        q: 'Ưu tiên thanh toán 1 lần không tham gia chia tiếp nghĩa là gì?',
        a: 'Khi bán công ty, nhà đầu tư chọn một trong hai: lấy lại đúng số vốn đã bỏ vào, hoặc chuyển ' +
           'sang cổ phần phổ thông và chia theo tỷ lệ. Đây là mức thông lệ ở vòng sớm. Bán cao thì họ ' +
           'chia theo tỷ lệ như mọi người; bán thấp thì họ lấy lại vốn trước.',
      },
      {
        q: 'Vì sao bảng cho thấy bán cao thì không mất gì?',
        a: 'Vì khi giá bán đủ cao, chia theo tỷ lệ có lợi hơn cho nhà đầu tư nên họ bỏ quyền ưu tiên. ' +
           'Điều khoản chỉ phát huy ở mức bán vừa phải, mà phần lớn thương vụ bán lại rơi vào khoảng đó.',
      },
      {
        q: 'Công cụ có tính được term sheet có nhiều vòng trước không?',
        a: 'Chưa. Công cụ giả định một lớp cổ phần ưu đãi của nhà đầu tư vòng này. Nếu công ty đã có ' +
           'nhà đầu tư ưu đãi từ vòng trước, thứ tự ưu tiên giữa các vòng sẽ đổi kết quả, và cần luật ' +
           'sư hoặc mô hình riêng.',
      },
      {
        q: 'Ký ở công ty Việt Nam thì các điều khoản này có áp dụng được không?',
        a: 'Tuỳ điều khoản và cách viết vào điều lệ, thoả thuận cổ đông. Nhiều startup Việt Nam gọi vốn ' +
           'qua công ty mẹ ở nước ngoài một phần vì lý do này. Hỏi luật sư trước khi ký, đặc biệt với ' +
           'ưu tiên thanh toán và chống pha loãng.',
      },
    ],
  },

  'growth-metrics': {
    intro:
      'Câu đầu tiên nhà đầu tư hỏi một công ty đã có doanh thu là: mỗi tháng tăng bao nhiêu, và có ' +
      'đều không. Công cụ này tính từ doanh thu thật của từng tháng, không từ kế hoạch, và chỉ ra ' +
      'chỗ con số dễ bị hỏi lại: tháng đột biến, tháng giảm, khách rời đi, phụ thuộc vài khách lớn.',
    faq: [
      {
        q: 'Tăng trưởng trung bình tính thế nào?',
        a: 'Là tăng trưởng kép mỗi tháng: lấy doanh thu tháng gần nhất chia doanh thu tháng đầu kỳ, rồi ' +
           'khai căn theo số tháng. Cách này không bị một tháng đột biến kéo lệch như khi cộng các mức ' +
           'tăng rồi chia trung bình.',
      },
      {
        q: 'Nên nói doanh thu chạy năm hay doanh thu 12 tháng?',
        a: 'Nói cả hai và ghi rõ cách tính. Doanh thu chạy năm (tháng gần nhất nhân 12) phản ánh quy mô ' +
           'hiện tại khi công ty tăng nhanh. Doanh thu 12 tháng thực thu là con số sổ sách. Lẫn hai con ' +
           'số này là cách nhanh nhất để mất lòng tin trong buổi thẩm định.',
      },
      {
        q: 'Tăng bao nhiêu mỗi tháng là tốt?',
        a: 'Tuỳ ngành, quy mô và giai đoạn, và site chưa có đủ dữ liệu Việt Nam để đưa một mốc chung. ' +
           'So với chính các tháng trước của bạn và với công ty cùng ngành hữu ích hơn một con số ' +
           'lấy từ thị trường nước ngoài.',
      },
    ],
  },

  'market-sizing': {
    intro:
      'Con số "thị trường 10 tỷ đô" lấy từ báo cáo ngành là thứ nhà đầu tư giai ' +
      'đoạn đầu bỏ qua ngay. Cái họ đọc là bạn suy ra con số đó bằng cách nào. ' +
      'Công cụ này dựng TAM, SAM, SOM từ chính giả định của bạn và soát xem giả ' +
      'định có vô lý không.',
    faq: [
      {
        q: 'TAM, SAM, SOM khác nhau thế nào?',
        a: 'TAM là toàn bộ thị trường nếu bạn phục vụ được tất cả. SAM là phần bạn ' +
           'thực sự tiếp cận được với sản phẩm và kênh hiện tại. SOM là phần bạn ' +
           'giành được trong vài năm tới. Cả ba phải dựng từ cùng một bộ giả định.',
      },
      {
        q: 'Chiếm bao nhiêu phần trăm thị trường là hợp lý?',
        a: 'Sau 3 năm, trên 10% là mức rất ít doanh nghiệp đạt được; sau 5 năm là ' +
           'trên 20%. Đặt tỷ lệ cao hơn thì cần lý do cụ thể, chẳng hạn thị trường ' +
           'có hiệu ứng mạng hoặc bạn đã có sẵn kênh phân phối.',
      },
      {
        q: 'Thị trường nhỏ thì có gọi được vốn không?',
        a: 'Vốn mạo hiểm cần đường đi tới quy mô gấp nhiều lần số tiền bỏ ra. Thị ' +
           'trường nhỏ không có nghĩa doanh nghiệp bạn không tốt, chỉ là quỹ mạo ' +
           'hiểm có thể không phải nguồn vốn phù hợp, và biết sớm thì đỡ mất thời gian.',
      },
    ],
  },

  'cap-table': {
    intro:
      'Sau ba vòng gọi vốn bạn còn lại bao nhiêu phần trăm? Câu hỏi này chỉ trả ' +
      'lời được khi nhìn cả chuỗi, vì mỗi vòng riêng lẻ trông đều hợp lý. Công cụ ' +
      'mô phỏng từ pre-seed tới Series A, gồm cả SAFE chuyển đổi và quỹ cổ phiếu ' +
      'thưởng mở rộng qua từng vòng.',
    faq: [
      {
        q: 'Sau vòng đầu nên giữ bao nhiêu phần trăm?',
        a: 'Thông lệ là 70–85%. Bán quá nhiều ở vòng đầu khiến các vòng sau chật ' +
           'chội, và quỹ vòng sau sẽ lo người sáng lập không còn đủ động lực đi ' +
           'hết chặng đường.',
      },
      {
        q: 'Vì sao một vòng trông bình thường lại lấy đi tới 35%?',
        a: 'Vì ba thứ cộng lại: phần bán cho nhà đầu tư mới, phần SAFE cũ chuyển ' +
           'đổi, và phần quỹ cổ phiếu thưởng mở rộng. Nhìn riêng từng khoản thì ' +
           'khoản nào cũng hợp lý.',
      },
      {
        q: 'Công cụ này khác gì công cụ SAFE?',
        a: 'Công cụ SAFE tính một vòng thật kỹ. Công cụ này nối nhiều vòng lại để ' +
           'thấy đường dài. Cả hai dùng chung một engine nên luôn cho cùng con số ' +
           'ở cùng một vòng.',
      },
    ],
  },

  'unit-economics-check': {
    intro:
      'Ở giai đoạn đầu gần như chưa ai có đủ dữ liệu để đo giá trị vòng đời khách ' +
      'hàng. Công cụ này không giả vờ đo. Nó soát xem giả định của bạn có vô lý ' +
      'không, và từ chối đưa ra con số như một số đo được khi dữ liệu còn quá mỏng.',
    faq: [
      {
        q: 'Vì sao công cụ không hiện giá trị vòng đời khi tôi có ít dữ liệu?',
        a: 'Vì con số đó tính từ hai tháng dữ liệu trông y hệt con số tính từ hai ' +
           'năm. Nhà đầu tư sẽ hỏi cohort bao nhiêu tháng, và câu trả lời sai chỗ ' +
           'đó làm hỏng phần còn lại của buổi họp. Nói thẳng "chúng tôi giả định" ' +
           'thì an toàn hơn nhiều.',
      },
      {
        q: 'Tỷ lệ vòng đời trên chi phí bao nhiêu là tốt?',
        a: 'Chuẩn thị trường là từ 3 lần trở lên. Dưới 1 lần nghĩa là bán càng ' +
           'nhiều càng lỗ. Trên 10 lần với dữ liệu vài tháng thì thường là giả ' +
           'định tỷ lệ rời bỏ quá lạc quan.',
      },
      {
        q: 'Số tháng hoàn vốn quan trọng thế nào?',
        a: 'Rất quan trọng ở giai đoạn đầu vì runway ngắn. Trên 18 tháng nghĩa là ' +
           'mỗi khách mới làm cạn tiền mặt trước khi sinh lời. Đây là rủi ro dòng ' +
           'tiền thật, không phải chuyện lý thuyết.',
      },
    ],
  },

  'pitch-deck': {
    intro:
      'Mười slide cần có thì tìm đâu cũng ra. Công cụ này khác ở chỗ nói rõ nhà ' +
      'đầu tư thực sự tìm gì trên từng slide, vì phần lớn deck lần đầu điền đúng ' +
      'tiêu đề nhưng sai nội dung. Đánh dấu slide bạn đã có để biết còn thiếu gì ' +
      'và nên làm slide nào trước.',
    faq: [
      {
        q: 'Deck nên dài bao nhiêu?',
        a: 'Deck gửi qua email thường được xem trong 3–4 phút. Giữ 10 slide chính, ' +
           'đẩy phần còn lại xuống phụ lục. Phụ lục dài bao nhiêu cũng được vì nó ' +
           'chỉ mở ra khi có người hỏi.',
      },
      {
        q: 'Chưa có traction thì slide bằng chứng viết gì?',
        a: 'Thư quan tâm, triển khai thử, danh sách chờ, hoặc kết quả phỏng vấn ' +
           'khách hàng. Nếu thật sự chưa có gì, hãy trung thực và nói kế hoạch lấy ' +
           'bằng chứng. Điều đó tốt hơn nhiều so với một slide đầy số liệu ngành.',
      },
      {
        q: 'Slide nào quan trọng nhất?',
        a: 'Đội ngũ và bằng chứng. Ở vòng angel và pre-seed chưa có mấy số liệu để ' +
           'đánh giá, nên nhà đầu tư đặt cược vào người và vào dấu hiệu có người ' +
           'thực sự cần thứ bạn làm.',
      },
    ],
  },

  'round-simulator': {
    intro:
      'Mỗi vòng gọi vốn riêng lẻ đều trông hợp lý: bán 20% cho quỹ, lập quỹ cổ ' +
      'phiếu thưởng 10%, chuyển đổi SAFE cũ. Chỉ khi nhìn cả chuỗi mới thấy phần ' +
      'của mình đi về đâu. Kéo thanh trượt định giá và số tiền gọi để thấy tỷ lệ ' +
      'sở hữu thay đổi ngay lập tức qua từng vòng.',
    faq: [
      {
        q: 'Vì sao một vòng trông bình thường lại lấy đi tới 35%?',
        a: 'Vì ba thứ cộng lại: phần bán cho nhà đầu tư mới, phần SAFE cũ chuyển ' +
           'đổi, và phần quỹ cổ phiếu thưởng mở rộng. Nhìn riêng thì khoản nào ' +
           'cũng hợp lý. Thử tắt bật SAFE trong công cụ để thấy khác biệt.',
      },
      {
        q: 'Định giá cao hơn thì luôn tốt hơn?',
        a: 'Kéo thử thanh trượt định giá vòng đầu lên rất cao rồi xem vòng sau. ' +
           'Định giá quá cao ở vòng đầu khiến vòng sau khó. Nếu chưa đạt cột mốc ' +
           'tương xứng, bạn sẽ phải gọi ở mức thấp hơn, điều nhà đầu tư hiện hữu ' +
           'rất ngại.',
      },
      {
        q: 'Sau ba vòng nên còn bao nhiêu phần trăm?',
        a: 'Thông lệ là giữ 70–85% sau vòng đầu và trên 50% sau Series A. Dưới 40% ' +
           'khi mới qua vài vòng là cấu trúc khó gọi tiếp, vì quỹ vòng sau lo người ' +
           'sáng lập không còn đủ động lực đi hết chặng đường.',
      },
    ],
  },

  'safe-convert': {
    intro:
      'Bạn ký SAFE 500 triệu với cap 8 tỷ. Rất nhiều người hiểu là đã bán 6,25%. ' +
      'Thực tế con số phụ thuộc vào việc SAFE là pre-money hay post-money, cap hay ' +
      'discount cái nào có lợi hơn cho nhà đầu tư, có bao nhiêu SAFE khác đang chờ, ' +
      'và quỹ cổ phiếu thưởng mở rộng lấy từ đâu. Công cụ này tính ra con số thật.',
    faq: [
      {
        q: 'SAFE pre-money và post-money khác nhau thế nào?',
        a: 'Với SAFE post-money (bản chuẩn từ 2018), nhà đầu tư biết chắc mình sở hữu ' +
           'bao nhiêu phần trăm và các SAFE không pha loãng lẫn nhau, và toàn bộ phần pha ' +
           'loãng do người sáng lập gánh. Với SAFE pre-money (bản 2013), các SAFE pha ' +
           'loãng lẫn nhau nên ký thêm SAFE sẽ làm giảm phần của người ký trước.',
      },
      {
        q: 'Có cả cap và discount thì nhà đầu tư được cả hai không?',
        a: 'Không. Nhà đầu tư chọn phương án nào cho họ nhiều cổ phần hơn, không cộng dồn. ' +
           'Cap thường có lợi hơn khi vòng sau định giá cao; discount có lợi hơn khi định ' +
           'giá vòng sau thấp hơn cap.',
      },
      {
        q: 'Vì sao SAFE cần có cap?',
        a: 'Vì không có cap, nhà đầu tư sớm có thể bị thiệt khi công ty tăng trưởng nhanh. Ví dụ ' +
           'SAFE chỉ có chiết khấu 30%, vòng sau định giá 500 tỷ: nhà đầu tư mua ở 350 tỷ, dù lúc ' +
           'họ rót tiền công ty có thể chỉ đáng vài chục tỷ. Cap là mức trần chặn tình huống này. ' +
           'Ngược lại, SAFE thường không có mức sàn, nên nếu vòng sau định giá thấp, nhà đầu tư ' +
           'nhận nhiều cổ phần hơn và founder gánh phần pha loãng.',
      },
      {
        q: 'Quỹ cổ phiếu thưởng mở rộng lấy từ đâu thì quan trọng thế nào?',
        a: 'Rất quan trọng và thường bị bỏ qua. Nếu lấy từ phần pre-money, chỉ người sáng ' +
           'lập và cổ đông cũ chịu; nhà đầu tư mới không mất gì. Đây là điều khoản đàm phán ' +
           'được. Thử đổi lựa chọn trong công cụ để thấy phần trăm của bạn thay đổi bao nhiêu.',
      },
    ],
  },
};

/** Nội dung mặc định cho các công cụ chưa xây. */
export function contentFor(tool) {
  return (
    TOOL_CONTENT[tool.toolId] || {
      intro: `${tool.blurb} Công cụ này đang được xây, sẽ có trong thời gian tới.`,
      faq: [],
    }
  );
}
